import axios from "axios"
import { API_BASE_URL } from "../shared/Config";

export const StorageService = {
    getStorage: async function(params:any, urlParams:any){
        const response = await axios.put(`${API_BASE_URL}/${urlParams.pool_id}/${urlParams.tenant}/storage`, params)
        
        return response
    }
}